import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  buttons: {
    margin: "0px 4px",
    borderRadius: "10px",
  },
}));
